import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './FloatingCartButton.css';

const FloatingCartButton = () => {
  const { getCartItemCount } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const cartItemCount = getCartItemCount();

  // Don't show on cart page or admin pages
  const shouldShow = cartItemCount > 0 &&
                     location.pathname !== '/cart' &&
                     !location.pathname.startsWith('/admin');

  if (!shouldShow) {
    return null;
  }

  return (
    <button
      type="button"
      className="floating-cart-button"
      onClick={() => navigate('/cart')}
      role="button"
      aria-label="Shopping cart"
    >
      <i className="fas fa-shopping-cart"></i>
      {cartItemCount > 0 && (
        <span className="cart-badge">{cartItemCount}</span>
      )}
    </button>
  );
};

export default FloatingCartButton;
